import { Button, CircularProgress } from '@mui/material';
import { FormattedMessage } from 'react-intl';

interface OtherActionsButtonProps {
  label: string;
  onClick: () => void;
  isLoading?: boolean;
  isDisabled?: boolean;
  startIcon?: React.ReactNode;
}

function OtherActionsButton({
  label,
  onClick,
  isLoading,
  isDisabled,
  startIcon,
}: OtherActionsButtonProps) {
  return (
    <Button
      disabled={isLoading || isDisabled}
      onClick={onClick}
      sx={{
        display: 'flex',
        height: '40px',
        padding: '8px 12px',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '12px',
        alignSelf: 'stretch',
        backgroundColor: 'rgba(246, 246, 246, 1)',
        color: 'rgba(93, 93, 93, 1)',
        textTransform: 'none',
        marginTop: '28px',
      }}
    >
      {isLoading ? (
        <>
          <CircularProgress
            size={20}
            style={{ marginRight: '8px', color: 'black' }}
          />
          <span style={{ color: 'black', textTransform: 'none' }}>
            <FormattedMessage defaultMessage='Loading...' />
          </span>
        </>
      ) : (
        <>
          {startIcon && startIcon}
          {label}
        </>
      )}
    </Button>
  );
}

export default OtherActionsButton;
